module.exports = __webpack_public_path__ + "static/media/Carosel P 4.06a54bac.svg";